import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {RESOURCE_USAGES_QUERY_KEY, SNIPPETS_QUERY_KEY} from "../queryKeys";
import {ReachSnippet, ReachSnippetCreatePayload} from "./types";

const createSnippet = async (payload: ReachSnippetCreatePayload): Promise<ReachSnippet> => {
  const response = await axiosReachInstance.post<ReachSnippet, AxiosResponse<ReachSnippet>, ReachSnippetCreatePayload>(
    "/snippets",
    payload
  );
  return response.data;
};

export const useCreateSnippet = (
  options?: BaseMutationOptions<ReachSnippet, ReachSnippetCreatePayload>
): BaseUseMutationResult<ReachSnippet, ReachSnippetCreatePayload> => {
  return useBaseMutation<ReachSnippet, ReachSnippetCreatePayload>(createSnippet, {
    ...options,
    prefixKeysToReset: () => [[SNIPPETS_QUERY_KEY], [RESOURCE_USAGES_QUERY_KEY]],
  });
};
